<template>
    <b-modal title="Holding"  no-close-on-backdrop hide-footer size="xl" v-model="largeModal" @ok="largeModal = false">
        <form>
            <div class="form-group row">
                <div class="col-sm-12">
                    <p><b>Bangla Name :</b> {{ roadAddress.bn_name}}</p>
                </div>
                <div class="col-sm-12">
                    <p><b>English Name :</b> {{roadAddress.en_name }}</p>
                </div>
                <div class="col-sm-12">
                    <p><b>Word No : </b> {{roadAddress.word_no }}</p>
                </div>

            </div>
        </form>
    </b-modal>
</template>

<script>
    export default {
        data(){
            return{
                largeModal:false,
                roadAddress:'',
            }
        },
        methods:{
            openModal(roadAddress){
                this.largeModal = true
                this.roadAddress = roadAddress
            },

        }

    }
</script>

<style>

</style>
